import React from "react";
import PropTypes from "prop-types";
import { AppleApp } from "assets/svg";
import plugin from "utils/currentPlugin";
import * as Styled from "./styles";

const brand = plugin ? plugin.name : "MRV";

const ButtonApple = ({ onClick, ...rest }) => {
  return (
    <Styled.ButtonApp
      liquid
      loading={false}
      onClick={onClick}
      show
      title="App Store"
      id="App Store"
      theme={brand}
      disableGtm
      variant="ghost"
      {...rest}
    >
      <Styled.ContainerButton>
        <Styled.ImgButton src={AppleApp} alt="Apple Alt" />
        <span>App Store</span>
      </Styled.ContainerButton>
    </Styled.ButtonApp>
  );
};

ButtonApple.propTypes = {
  onClick: PropTypes.func.isRequired
};

ButtonApple.defaultProps = {};

export default ButtonApple;
